// import React, { useEffect, useState } from 'react';
// import Swal from '../librarianSwal';
// import { useAuth } from '../../Constant/Auth';
import { useActiveLibraryId } from '../../Constant/useActiveLibrary';

// import {
//   getActiveBookCategoriesByLibrary,
//   addBook,
//   addBookCopy,
//   getErrorMessage
// } from '../../api/api';

// const parseCSV = (text) => {
//   const lines = text.split(/\r?\n/).filter((line) => line.trim());
//   if (lines.length < 2) return [];

//   const headers = lines[0].split(',').map((h) => h.trim());

//   return lines.slice(1).map((line) => {
//     const values = line.split(',').map((v) => v.trim());
//     const row = {};

//     headers.forEach((header, index) => {
//       row[header] = values[index] || '';
//     });

//     return row;
//   });
// };

// const BookBulkImport = () => {
//   const { user } = useAuth();
//   const libraryId = useActiveLibraryId();

//   const [rows, setRows] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fetchCategories = async () => {
//     try {
//       if (!libraryId) return;

//       const data = await getActiveBookCategoriesByLibrary(libraryId);
//       setCategories(data || []);
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [libraryId]);

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const reader = new FileReader();

//     reader.onload = (event) => {
//       const parsedRows = parseCSV(event.target.result);
//       setRows(parsedRows);
//     };

//     reader.readAsText(file);
//   };

//   const getBookId = (bookResult) => {
//     return (
//       bookResult?.insertId ||
//       bookResult?.id ||
//       bookResult?.data?.insertId ||
//       bookResult?.data?.id
//     );
//   };

//   const handleImport = async () => {
//     if (!libraryId) {
//       Swal.fire('Error', 'Library ID not found', 'error');
//       return;
//     }

//     if (rows.length === 0) {
//       Swal.fire('Error', 'Please select CSV file first', 'error');
//       return;
//     }

//     const confirm = await Swal.fire({
//       title: 'Import Books?',
//       text: `${rows.length} book rows will be imported.`,
//       icon: 'question',
//       showCancelButton: true,
//       confirmButtonText: 'Import'
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       setLoading(true);

//       for (const row of rows) {
//         const bookPayload = {
//           library_id: libraryId,
//           category_id: row.category_id,
//           title: row.title,
//           subtitle: row.subtitle || null,
//           author_name: row.author_name || null,
//           publisher_name: row.publisher_name || null,
//           isbn: row.isbn || null,
//           edition: row.edition || null,
//           language: row.language || null,
//           publish_year: row.publish_year || null,
//           description: row.description || null,
//           cover_image: null,
//           late_fine_per_day_override: row.late_fine_per_day_override || null,
//           lost_charge_override: row.lost_charge_override || null,
//           damage_charge_override: row.damage_charge_override || null,
//           status: row.status || 'active'
//         };

//         const bookResult = await addBook(bookPayload);
//         const bookId = getBookId(bookResult);

//         if (!bookId) {
//           throw new Error(`Book ID not received for ${row.title}`);
//         }

//         const totalCopies = Number(row.num_copies || 1);

//         for (let i = 1; i <= totalCopies; i++) {
//           const accessionNo = `${row.accession_prefix || `ACC-${bookId}`}-${i}`;
//           const barcode = `${row.barcode_prefix || row.accession_prefix || `BAR-${bookId}`}-${i}`;

//           const copyPayload = {
//             book_id: bookId,
//             accession_no: accessionNo,
//             barcode,
//             catalogue_no: row.catalogue_no || null,
//             copy_number: i,
//             room_no: row.room_no || null,
//             almirah_no: row.almirah_no || null,
//             rack_no: row.rack_no || null,
//             shelf_no: row.shelf_no || null,
//             row_no: row.row_no || null,
//             purchase_date: row.purchase_date || null,
//             purchase_price: row.purchase_price || null,
//             vendor_name: row.vendor_name || null,
//             condition_status: 'good',
//             availability_status: 'available',
//             is_reference_only: row.is_reference_only === '1' ? 1 : 0,
//             is_discarded: 0,
//             discarded_at: null,
//             discard_reason: null,
//             remarks: row.remarks || null
//           };

//           await addBookCopy(copyPayload);
//         }
//       }

//       Swal.fire('Success', 'Books imported successfully', 'success');
//       setRows([]);
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadSample = () => {
//     const csv = [
//       'category_id,title,subtitle,author_name,publisher_name,isbn,edition,language,publish_year,description,num_copies,accession_prefix,barcode_prefix,catalogue_no,room_no,almirah_no,rack_no,shelf_no,row_no,purchase_date,purchase_price,vendor_name,status',
//       '1,Mathematics Book,,R S Aggarwal,ABC Publisher,9781234567890,1,English,2026,Math book,2,ACC-MATH,BAR-MATH,CAT-001,R1,A1,RK1,S1,ROW1,2026-01-01,500,ABC Vendor,active'
//     ].join('\n');

//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);

//     const a = document.createElement('a');
//     a.href = url;
//     a.download = 'book_import_sample.csv';
//     a.click();

//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="container-fluid mt-3">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div className="top-text-align">
//           <h3 className="mb-0">Book Bulk Import</h3>
//           <small className="text-muted">Import books and physical copies using CSV</small>
//         </div>

//         <button className="btn btn-outline-primary" onClick={downloadSample}>
//           Download Sample CSV
//         </button>
//       </div>

//       <div className="card shadow-sm mb-3 table-full-card">
//         <div className="card-body">
//           <label className="form-label">Upload CSV File</label>
//           <input
//             type="file"
//             accept=".csv"
//             className="form-control"
//             onChange={handleFileChange}
//           />

//           <div className="mt-2">
//             <strong>Active Categories:</strong>
//             <div className="small text-muted">
//               {categories.map((category) => `${category.id} = ${category.name}`).join(', ')}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="card shadow-sm table-full-card">
//         <div className="card-header d-flex justify-content-between align-items-center">
//           <span className="fw-bold"><i className="fas fa-table me-2" />Preview</span>

//           <button
//             className="btn btn-primary btn-sm"
//             onClick={handleImport}
//             disabled={loading || rows.length === 0}
//           >
//             {loading ? 'Importing...' : 'Import Books'}
//           </button>
//         </div>

//         <div className="card-body">
//           <div className="table-responsive">
//             <table className="table table-bordered table-hover align-middle">
//               <thead className="table-light">
//                 <tr>
//                   <th>#</th>
//                   <th>Category ID</th>
//                   <th>Title</th>
//                   <th>Author</th>
//                   <th>ISBN</th>
//                   <th>Copies</th>
//                   <th>Accession Prefix</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {rows.map((row, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{row.category_id}</td>
//                     <td>{row.title}</td>
//                     <td>{row.author_name}</td>
//                     <td>{row.isbn}</td>
//                     <td>{row.num_copies || 1}</td>
//                     <td>{row.accession_prefix}</td>
//                   </tr>
//                 ))}

//                 {rows.length === 0 && (
//                   <tr>
//                     <td colSpan="7" className="text-center text-muted py-4">
//                       No CSV data selected
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookBulkImport;



import React, { useEffect, useState } from 'react';
import Swal from '../librarianSwal';
import { useAuth } from '../../Constant/Auth';

import {
  getActiveBookCategoriesByLibrary,
  addBook,
  addBookCopy,
  getErrorMessage
} from '../../api/api';
import '../lib-page-header.css';

const parseCSVLine = (line) => {
  const result = [];
  let current = '';
  let insideQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"' && insideQuotes && nextChar === '"') {
      current += '"';
      i++;
    } else if (char === '"') {
      insideQuotes = !insideQuotes;
    } else if (char === ',' && !insideQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current.trim());
  return result;
};

const parseCSV = (text) => {
  const lines = text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length < 2) return [];

  const headers = parseCSVLine(lines[0]).map((h) => h.trim());

  return lines.slice(1).map((line) => {
    const values = parseCSVLine(line);
    const row = {};

    headers.forEach((header, index) => {
      row[header] = values[index] || '';
    });

    return row;
  });
};

const toNumberOrNull = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

const cleanText = (value) => {
  if (value === undefined || value === null) return null;
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
};

const getBookId = (bookResult) => {
  return (
    bookResult?.insertId ||
    bookResult?.id ||
    bookResult?.book_id ||
    bookResult?.data?.insertId ||
    bookResult?.data?.id ||
    bookResult?.data?.book_id ||
    bookResult?.data?.data?.insertId ||
    bookResult?.data?.data?.id ||
    bookResult?.data?.data?.book_id
  );
};

const BookBulkImport = () => {
  const libraryId = useActiveLibraryId();

  const [rows, setRows] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      if (!libraryId) return;

      const result = await getActiveBookCategoriesByLibrary(libraryId);

      const categoryList =
        Array.isArray(result)
          ? result
          : Array.isArray(result?.data)
            ? result.data
            : Array.isArray(result?.data?.data)
              ? result.data.data
              : [];

      setCategories(categoryList);
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    }
  };

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryId]);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      const parsedRows = parseCSV(event.target.result || '');
      setRows(parsedRows);
    };

    reader.readAsText(file);
  };

  const validateRow = (row, index) => {
    const rowNumber = index + 1;

    if (!cleanText(row.category_id)) {
      throw new Error(`Row ${rowNumber}: category_id is required`);
    }

    if (!cleanText(row.title)) {
      throw new Error(`Row ${rowNumber}: title is required`);
    }

    const isValidCategory = categories.some(
      (category) => Number(category.id) === Number(row.category_id)
    );

    if (!isValidCategory) {
      throw new Error(
        `Row ${rowNumber}: Invalid category_id ${row.category_id} for "${row.title}". Please use active category ID.`
      );
    }

    const totalCopies = Number(row.num_copies || 1);

    if (Number.isNaN(totalCopies) || totalCopies < 1) {
      throw new Error(`Row ${rowNumber}: num_copies must be 1 or more`);
    }
  };

  const handleImport = async () => {
    if (!libraryId) {
      Swal.fire('Error', 'Library ID not found', 'error');
      return;
    }

    if (rows.length === 0) {
      Swal.fire('Error', 'Please select CSV file first', 'error');
      return;
    }

    try {
      rows.forEach((row, index) => validateRow(row, index));
    } catch (error) {
      Swal.fire('Validation Error', error.message, 'error');
      return;
    }

    const confirm = await Swal.fire({
      title: 'Import Books?',
      text: `${rows.length} book rows will be imported.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Import'
    });

    if (!confirm.isConfirmed) return;

    try {
      setLoading(true);

      for (const [index, row] of rows.entries()) {
        const rowNumber = index + 1;

        const bookPayload = {
          library_id: Number(libraryId),
          category_id: Number(row.category_id),
          title: cleanText(row.title),
          subtitle: cleanText(row.subtitle),
          author_name: cleanText(row.author_name),
          publisher_name: cleanText(row.publisher_name),
          isbn: cleanText(row.isbn),
          edition: cleanText(row.edition),
          language: cleanText(row.language),
          publish_year: toNumberOrNull(row.publish_year),
          description: cleanText(row.description),
          cover_image: null,
          late_fine_per_day_override: toNumberOrNull(row.late_fine_per_day_override),
          lost_charge_override: toNumberOrNull(row.lost_charge_override),
          damage_charge_override: toNumberOrNull(row.damage_charge_override),
          status: cleanText(row.status) || 'active'
        };

        const bookResult = await addBook(bookPayload);
        const bookId = getBookId(bookResult);

        if (!bookId) {
          throw new Error(`Row ${rowNumber}: Book ID not received for "${row.title}"`);
        }

        const totalCopies = Number(row.num_copies || 1);

        const safeTitle = String(row.title || 'BOOK')
          .replace(/[^a-zA-Z0-9]/g, '')
          .toUpperCase()
          .slice(0, 10);

        const accessionBase = cleanText(row.accession_prefix)
          ? `${cleanText(row.accession_prefix)}-${bookId}`
          : `ACC-${bookId}-${safeTitle}`;

        const barcodeBase = cleanText(row.barcode_prefix)
          ? `${cleanText(row.barcode_prefix)}-${bookId}`
          : `BAR-${bookId}-${safeTitle}`;

        for (let i = 1; i <= totalCopies; i++) {
          const accessionNo = `${accessionBase}-${i}`;
          const barcode = `${barcodeBase}-${i}`;

          const copyPayload = {
            library_id: Number(libraryId),
            book_id: Number(bookId),
            accession_no: accessionNo,
            barcode: barcode,
            catalogue_no: cleanText(row.catalogue_no),
            copy_number: i,

            room_no: cleanText(row.room_no),
            almirah_no: cleanText(row.almirah_no),
            rack_no: cleanText(row.rack_no),
            shelf_no: cleanText(row.shelf_no),
            row_no: cleanText(row.row_no),

            purchase_date: cleanText(row.purchase_date),
            purchase_price: toNumberOrNull(row.purchase_price),
            vendor_name: cleanText(row.vendor_name),

            condition_status: cleanText(row.condition_status) || 'good',
            availability_status: 'available',

            is_reference_only:
              row.is_reference_only === '1' ||
              String(row.is_reference_only).toLowerCase() === 'true'
                ? 1
                : 0,

            is_discarded: 0,
            discarded_at: null,
            discard_reason: null,
            remarks: cleanText(row.remarks)
          };

          await addBookCopy(copyPayload);
        }
      }

      Swal.fire('Success', 'Books imported successfully', 'success');
      setRows([]);
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  const downloadSample = () => {
    const firstCategoryId = categories?.[0]?.id || '';

    if (!firstCategoryId) {
      Swal.fire('Error', 'No active category found. Please create/activate a category first.', 'error');
      return;
    }

    const csv = [
      [
        'category_id',
        'title',
        'subtitle',
        'author_name',
        'publisher_name',
        'isbn',
        'edition',
        'language',
        'publish_year',
        'description',
        'num_copies',
        'accession_prefix',
        'barcode_prefix',
        'catalogue_no',
        'room_no',
        'almirah_no',
        'rack_no',
        'shelf_no',
        'row_no',
        'purchase_date',
        'purchase_price',
        'vendor_name',
        'condition_status',
        'is_reference_only',
        'status',
        'remarks'
      ].join(','),

      [
        firstCategoryId,
        'Mathematics Book',
        '',
        'R S Aggarwal',
        'ABC Publisher',
        '9781234567890',
        '1',
        'English',
        '2026',
        'Math book',
        '2',
        'ACC-MATH',
        'BAR-MATH',
        'CAT-001',
        'R1',
        'A1',
        'RK1',
        'S1',
        'ROW1',
        '2026-01-01',
        '500',
        'ABC Vendor',
        'good',
        '0',
        'active',
        'Sample book'
      ].join(',')
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'book_import_sample.csv';
    a.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="container-fluid mt-3">
      <div className="lib-page-header">
        <div className="lib-page-header__left">
          <div className="lib-page-header__icon">
            <i className="fas fa-file-import" />
          </div>
          <div>
            <h3 className="lib-page-header__title">Book Bulk Import</h3>
            <div className="lib-page-header__subtitle">Import books and physical copies using CSV</div>
          </div>
        </div>
        <div className="lib-page-header__actions">
          <button className="btn btn-outline-primary" onClick={downloadSample}>
            Download Sample CSV
          </button>
        </div>
      </div>

      <div className="card shadow-sm mb-3 table-full-card">
        <div className="card-body">
          <label className="form-label">Upload CSV File</label>

          <div className="input-group">
            <input
              type="file"
              accept=".csv"
              className="form-control"
              onChange={handleFileChange}
              disabled={loading}
            />
            <button
              className="btn btn-primary"
              onClick={handleImport}
              disabled={loading || rows.length === 0}
            >
              {loading ? (
                <><span className="spinner-border spinner-border-sm me-1" />Importing...</>
              ) : (
                <><i className="fas fa-file-import me-1" />Import Books</>
              )}
            </button>
          </div>

          <div className="mt-2 text-center">
            <strong>Active Categories:</strong>

            <div className="small text-muted">
              {categories.length > 0
                ? categories.map((category) => `${category.id} = ${category.name}`).join(', ')
                : 'No active categories found'}
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm table-full-card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span className="fw-bold">
            <i className="fas fa-table me-2" />
            Preview
          </span>

          {/* <button
            className="btn btn-primary btn-sm"
            onClick={handleImport}
            disabled={loading || rows.length === 0}
          >
            {loading ? 'Importing...' : 'Import Books'}
          </button> */}
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Category ID</th>
                  <th>Title</th>
                  <th>Author</th>
                  <th>ISBN</th>
                  <th>Copies</th>
                  <th>Accession Prefix</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.category_id}</td>
                    <td>{row.title}</td>
                    <td>{row.author_name}</td>
                    <td>{row.isbn}</td>
                    <td>{row.num_copies || 1}</td>
                    <td>{row.accession_prefix}</td>
                    <td>{row.status || 'active'}</td>
                  </tr>
                ))}

                {rows.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      No CSV data selected
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {rows.length > 0 && (
            <div className="small text-muted mt-2">
              Total rows selected: {rows.length}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookBulkImport;